<div class="dialog-container" [ngClass]="getBackgroundClass()">
  <div class="inner-container">
    <div class="carousel">
      <div class="card" *ngFor="let question of getQuestions(); index as i" [ngClass]="getCardClasses(i)" (click)="handleCardClick(i)">
        <div class="cardHeader">
          <p>{{i + 1}}/{{cardCount}}</p>
        </div>
        <div class="cardContent">
          <div class="imgHolder">
            <img [src]="getImgSrc(i)" onerror="this.style.display='none'" />
          </div>
          <div class="cardText">
            <h1>{{question.question}}</h1>
            <div *ngIf="typeIsButton(i)" class="inputs" [ngClass]="{'multi-button': question.multiAnswer}">
              <button mat-button class="text-button answer-button"
                [ngClass]="{'selected': getAnswerSelected(i, answer), 'multiSelect': question.multiAnswer}"
                (click)="buttonClicked(answer)" *ngFor="let answer of question.answers">
                {{answer.answer}}
              </button>
            </div>
            <div *ngIf="!typeIsButton(i)" class="inputs input-area">
              <div class="input-container double">
                <input *ngIf="typeIsInput(i)" type="text" class="input" placeholder="Enter an answer" [(ngModel)]="selections[i]" />
                <button mat-button *ngIf="typeIsDate(i)" class="input date text-button" (click)="chooseDate(i)">
                  <img class="date-icon" [src]="getDateIcon(i)" onerror="this.style.display='none'" />
                  <span class="date-text" [ngClass]="{'placeholder-text': !hasDate(i)}">{{getDateText(i)}}</span>
                  <img *ngIf="hasDate(i)" class="date-clear-icon" src="./assets/content-icon/ic-05.svg" onerror="this.style.display='none'" (click)="clearPressed($event, i)" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" *ngVar="(cardCount - 1) as i" [ngClass]="getCardClasses(i)" (click)="handleCardClick(i)">
        <div class="cardHeader">
          <p>{{cardCount}}/{{cardCount}}</p>
        </div>
        <div class="cardContent">
          <div class="imgHolder small">
            <img src="{{getImgSrc(i)}}" />
          </div>
          <div class="cardText">
            <h1 class="small">
              {{data?.assessment?.conclusionText}}
            </h1>
            <button mat-button class="text-button answer-button" (click)="buttonClicked()">
              Got It!
            </button>
            <div class="sourceInfo" *ngIf="hasAttribution()">
              Questions, data and risk analysis derived from
              <span *ngIf="hasAttributionLink()">
                <a target="_blank" href="{{data.assessment.attributionLink}}">guidance provided by {{data.assessment.attribution}}</a>.
              </span>
              <span *ngIf="!hasAttributionLink()">guidance provided by {{data.assessment.attribution}}.</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="cardIndex > 0" class="arrow left" (click)="move(false)">
        <img class="icon" src="./assets/content-icon/ic-07.svg" />
      </div>
      <div *ngIf="cardIndex < cardCount - 1" class="arrow right" (click)="move(true)">
        <img class="icon" src="./assets/content-icon/ic-07.svg" />
      </div>
    </div>
    <div class="progress-bar">
      <div class="progress-bar-layer background">
        <div class="progress" *ngFor="let _ of progressArray"></div>
      </div>
      <div class="progress-bar-layer" [style]="getProgressBarStyle()">
        <div class="progress" *ngFor="let _ of progressArray"></div>
      </div>
    </div>
  </div>
</div>